import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { ChannelRecordingTaskType, ChannelRecordingTaskTypeEnum } from '../types';

import { channelRecordingTasksKeys } from './query-keys';

export type TPostChannelRecordingTaskParams = {
  description: string;
  channel_id: string;
  production_center_id: string;
  segment_duration: number;
  start_datetime: string;
  end_datetime: string;
  recording_task_type: ChannelRecordingTaskTypeEnum;
};

export async function postChannelRecordingTask(
  body: TPostChannelRecordingTaskParams
): Promise<ChannelRecordingTaskType> {
  return mediaManagerClient.post('/api/v1/channel_recording_tasks', emptyStringValues(body));
}

type MutationFn = typeof postChannelRecordingTask;

type TUsePostChannelRecordingTaskParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostChannelRecordingTask({
  config = {},
}: TUsePostChannelRecordingTaskParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: postChannelRecordingTask,
    onError(error) {
      addErrorNotification(t('No se ha podido crear la grabación'));
      console.error(error);
    },
    onSuccess: () => {
      addSuccessNotification(t('La grabación se ha creado'));
      queryClient.invalidateQueries({ queryKey: channelRecordingTasksKeys.all });
    },
  });
}
